import requestService from "../requestService";
import store from '@/store';

export default {
    async createFeedback(form) {
        const response = await requestService.post(`/feedback-forms/create`, form)
        return response?.data
    },
    async updateFeedback(uuid, form) {
        const response = await requestService.post(`/admin/feedback-forms/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getFeedbacks(status, date) {
        const response = await requestService.get(`/admin/feedback-forms?${status ? `status=${status}&` : ''}${date ? `${date}` : ''}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getFeedbackStatuses() {
        const response = await requestService.get(`/admin/feedback-forms/statuses`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getFeedback(id) {
        const response = await requestService.get(`/admin/feedback-forms/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteFeedback(id) {
        const response = await requestService.delete(`/admin/feedback-forms/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
}